import { gql } from "graphql-request"
import { ServiceGraphql } from "./Graphql"

export const graphGetProfile = async () => {
  const PROFILE = gql`
  query Customer {
    Customer {
      authenType
      baseAddress
      cardAddress
      clientNumber
      company
      customerName
      customerReference {
        name
        phoneNumber
        referenceNote
        referenceType
      }
      customerType
      dob
      email
      flag
      gender
      id
      idCardNumber
      idCardType
      issueDate
      issuePlace
      nationality
      occupation {
        id
        occupationName
      }
      perAddress
      phoneNumber
      position {
        id
        positionName
      }
      salary
    }
  }
  `
  const response = await ServiceGraphql.request(PROFILE);
  return response.Customer;
}

export const graphChangeAuthenType = async (authenType) => {
  const CHANGE_AUTHEN = gql`
  mutation ChangeAuthenType($authenType: String!) {
    ChangeAuthenType(authenType: $authenType)
  }
  `

  const variables = {
    "authenType": authenType
  }

  const response = await ServiceGraphql.request(CHANGE_AUTHEN, variables);
  return response.ChangeAuthenType;
}

export const graphGenOtpQRCode = async() => {
  const GEN_QR_CODE = gql`
  mutation GenerateOtpQRCode {
    GenerateOtpQRCode
  }
  `

  const response = await ServiceGraphql.request(GEN_QR_CODE);
  return response.GenerateOtpQRCode
}

export const graphUpdateProfile = async (data) => {
  const UPDATE_PROFILE = gql`
  mutation UpdateCustomer($data: CustomerUpdateInput!) {
    UpdateCustomer(data: $data) {
      baseAddress
      cardAddress
      email
      perAddress
      company
      customerReference {
        name
        phoneNumber
        referenceNote
        referenceType
      }
      occupation {
        id
        occupationName
      }
      position {
        id
        positionName
      }
      salary
    }
  }
  `
  
  const variables = {
    "data": {
      "baseAddress": data.baseAddress,
      "cardAddress": data.cardAddress,
      "email": data.email,
      "perAddress": data.perAddress,
      "company": data.company,
      "salary": data.salary,
      "occupationId": data.occupationId,
      "positionId": data.positionId,
    }
  }

  const response = await ServiceGraphql.request(UPDATE_PROFILE, variables);
  return response.UpdateCustomer
}

export const graphUpdateAdditionalInfo = async (data) => {
  const UPDATE_ADDITIONAL_INFO = gql`
  mutation UpdateCustomer($data: CustomerUpdateInput!) {
    UpdateCustomer(data: $data) {
      company
      occupation {
        id
        occupationName
      }
      position {
        id
        positionName
      }
      salary
    }
  }
  `
  
  const variables = {
    "data": {
      "company": data.company,
      "salary": parseInt(data.salary),
      "occupationId": parseInt(data.occupationId),
      "positionId": parseInt(data.positionId),
    }
  }

  const response = await ServiceGraphql.request(UPDATE_ADDITIONAL_INFO, variables);
  return response.UpdateCustomer
}